module.exports = __webpack_public_path__ + "img/Group3.a0c79e54.png";